import LinkConstants from 'constants/LinkConstants';
import { SyncType } from 'globalTypes';

export default {
  ONEROSTER: {
    image: require('assets/images/rostering/csv-oneroster.png'),
    continueWith: 'OneRoster',
    switchTo: 'Remind CSV 2.0',
    footerText: 'Remind CSV 2.0 format',
    footerNextSyncType: SyncType.remindSpreadsheetV2,
    text: 'Remind OneRoster CSV format',
    textLink: LinkConstants.FORMAT_ONEROSTER,
    subtext: 'Remind',
    nextSyncType: SyncType.remindSpreadsheetV2,
  },
  REMIND: {
    image: require('assets/images/rostering/csv-remindv1.png'),
    continueWith: 'Remind CSV 1.0',
    switchTo: 'Remind CSV 2.0',
    footerText: 'Remind CSV 2.0 format',
    footerNextSyncType: SyncType.remindSpreadsheetV2,
    text: 'old Remind CSV format 1.0',
    textLink: LinkConstants.FORMAT_REMIND,
    subtext: 'Remind OneRoster',
    nextSyncType: SyncType.oneRosterSpreadsheet,
  },
  REMIND2: {
    image: require('assets/images/rostering/csv-remindv2.png'),
    continueWith: 'Remind CSV 2.0',
    switchTo: 'OneRoster',
    footerText: 'Remind CSV format 1.0',
    footerNextSyncType: SyncType.remindSpreadsheet,
    text: 'Remind CSV 2.0 format',
    textLink: LinkConstants.FORMAT_REMINDV2,
    subtext: 'Remind OneRoster',
    nextSyncType: SyncType.oneRosterSpreadsheet,
  },
};
